/**
 * Mobile "Read more" for the collection banner description.
 *
 * The clamp is applied by JS, never by CSS alone: if the script fails the copy must stay
 * fully readable rather than truncated with no way to expand it. The button is only revealed
 * when the text actually overflows the clamp, so short descriptions get no control.
 */
(() => {
  const MOBILE = '(max-width: 749px)';

  const init = (banner) => {
    const text = banner.querySelector('.cl-banner__text');
    const button = banner.querySelector('.cl-banner__more');
    if (!text || !button) return;

    const setLabel = (expanded) => {
      button.textContent = expanded ? button.dataset.less : button.dataset.more;
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    };

    const apply = () => {
      if (!window.matchMedia(MOBILE).matches) {
        banner.classList.remove('cl-banner--clamped', 'is-expanded');
        button.hidden = true;
        return;
      }

      // Measure unclamped, then clamp. The clamp uses `overflow: clip`, which creates no
      // scroll container, so scrollHeight equals clientHeight once it is applied — comparing
      // them after the fact would report no overflow and the button would never appear.
      banner.classList.remove('is-expanded', 'cl-banner--clamped');
      setLabel(false);
      const full = text.scrollHeight;

      banner.classList.add('cl-banner--clamped');
      const overflows = full - text.clientHeight > 2;

      button.hidden = !overflows;
      if (!overflows) banner.classList.remove('cl-banner--clamped');
    };

    button.addEventListener('click', () => {
      setLabel(banner.classList.toggle('is-expanded'));
    });

    apply();

    let timer;
    window.addEventListener('resize', () => {
      clearTimeout(timer);
      timer = setTimeout(apply, 150);
    });
  };

  document.querySelectorAll('.cl-banner').forEach(init);
})();
